import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_garmin_hr extends Component {
    constructor(props) {
        super(props);
        //this.chartRef = React.createRef();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        //const myChartRef = this.chartRef.current.getContext("2d");
        var ctx = document.getElementById('Chart_garmin_hr').getContext('2d');
        const min_data = this.props.data[3]['value'];
        const max_data = this.props.data[4]['value'];
        const avg_data = this.props.data[5]['value'];
        const rest_data = this.props.data[6]['value'];
        const date = this.props.data[5]['time'];
        var x_min = [];
        var x_max = [];
        var x_avg = [];
        var x_rest = [];
        var y_data = [];
        for (var i = 0; i < avg_data.length; i++) {
            x_min.push(min_data[i]);
            x_max.push(max_data[i]);
            x_avg.push(avg_data[i]);
            x_rest.push(rest_data[i]);
            var tmp = format(new Date(date[i]), "yyyy/MM/dd");
            y_data.push(tmp);
        }
        var isstepped = false;
        if (window.Chart_garmin_hr instanceof Chart) window.Chart_garmin_hr.destroy();
        window.Chart_garmin_hr = new Chart(ctx, {
            type: "line",
            // plugins: [ChartDataLabels],
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Min Heart Rate (bpm)',
                        data: x_min,
                        steppedLine: isstepped,
                        backgroundColor: '#a7cc7b',
                        borderColor: '#a7cc7b',
                        fill: false,
                        tension: '0',
                        datalabels: {
                            //     anchor: 'start',
                            //     align: 'start',
                            //     formatter: Math.round,
                            //     font: {
                            //         weight: 'bold'
                            //     }
                            display: false
                        }
                    },
                    {
                        label: 'MAX Heart Rate (bpm)',
                        data: x_max,
                        steppedLine: isstepped,
                        backgroundColor: '#260154',
                        borderColor: '#260154',
                        fill: false,
                        tension: '0',
                        datalabels: {
                            //     anchor: 'end',
                            //     align: 'top',
                            //     formatter: Math.round,
                            //     font: {
                            //         weight: 'bold'
                            //     }
                            display: false
                        }
                    },
                    {
                        label: 'Average Heart Rate (bpm)',
                        data: x_avg,
                        steppedLine: isstepped,
                        backgroundColor: 'rgba(252, 25, 25, 1)',
                        borderColor: 'rgba(252, 25, 25, 1)',
                        fill: false,
                        tension: '0',
                        datalabels: {
                            // anchor: 'end',
                            // align: 'top',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'Rest Heart Rate (bpm)',
                        data: x_rest,
                        steppedLine: isstepped,
                        backgroundColor: '##a0522d',
                        borderColor: '##a0522d',
                        fill: false,
                        tension: '0',
                        datalabels: {
                            // anchor: 'end',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                scales: {
                    xAxes: [{
                        type: 'time',
                        offset: true,
                        time: {
                            unit: 'day'
                        }
                    }]
                },
                title: {
                    display: true,
                    text: "Daily Heart Rate",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_garmin_hr"></canvas>
            </div>
        );
    }
}